// extracted by mini-css-extract-plugin
module.exports = {"container":"ExtensionInstall__container__9uGA8 layout__fill-center__3V8Ju","badgeList":"ExtensionInstall__badgeList__oZwIH"};